import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Row, Col } from "react-bootstrap";
import { useGetBannerDataQuery } from "../../../../services/homeAPI";
import "./style.scss";
import { Link } from "react-router-dom";
import { useGetColorThemeQuery } from "../../../../services/commonAPI";
import Loader from "../../fullPageLoader";

function Carousel() {
  const { data: bannerData, error, isLoading } = useGetBannerDataQuery();
  const settings = {
    dots: true,
    lazyLoad: 'ondemand',
    infinite: bannerData?.length > 1, // Disable infinite scroll if there's only one slide
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    variableWidth: false, // Ensure proper sizing
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };




  const { data: colorthemeData } = useGetColorThemeQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  return (
    <section
      className="home-banner"
      style={{
        backgroundColor:
          colorthemeData?.color_themes?.[0]?.banner_bg_color || "#F1EEEE",
      }}
    >
     
      <div className="container-fluid p-0 m-0 banner-content">
        <Slider {...settings}>
          {bannerData?.map((data) => (
            <div 
            >

              <Row className="align-items-center justify-content-center m-0" style={{
                backgroundImage: data.desktop_image_url ? `url("${data.desktop_image_url}")` : "none",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}>
                 <div className="home-banner-overlay"></div>
                <Col xs={12} md={5} lg={5} className="text-start">
                <div className="home-banner-content">
                <h3
                   
                   data-aos="fade-down"
                 >
                   {data.title}
                 </h3>
                 {data?.button_is_active === 1 && (
                   <Link to={data.button_url}>
                     <button
                       className="primary-button"
                       style={{
                         backgroundColor:
                           colorthemeData?.color_themes?.[0]?.primary_color ||
                           "#a76d50",
                       }}
                        data-aos="fade-down"
                     >
                       {data?.button_text}
                     </button>
                   </Link>
                 )}
                </div>
                 
                </Col>
               
              </Row>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default Carousel;
